export const onEnter = ({ state }) => state;
export const onLeave = ({ state }) => state;
export const executeRequest = ({ state }) => state;
